import React from 'react';
import { useModelGroupsQuery } from '../../../AdviserSettings/Page/Models/api/useModelGroupsQuery';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { Tab, TabList, TabPanel, Tabs } from '../../../CommonComponents/OPL/Tab';

import {
  AssetAllocationModelDTO,
  MANUAL_ACCOUNTS_ASSET_ALLOCATION_TAX_STATUSES,
  ManualAccountsAssetAllocationDTO,
} from '../../../ManualAccountsAssetAllocation/types';
import { PortfolioPicker } from '../../../Profile/RiskTolerance/components/PortfolioPicker';
import { formatPercentage } from '../../../CommonUtils/formatNumber';

interface Props {
  currentAllocation: ManualAccountsAssetAllocationDTO;
  setCurrentAllocation: (allocation: ManualAccountsAssetAllocationDTO) => void;
  clientId?: number;
}

export const MyModel = ({ currentAllocation, clientId, setCurrentAllocation }: Props) => {
  const { data: modelGroups, isLoading } = useModelGroupsQuery(clientId ? { clientId } : undefined);

  if (isLoading) {
    return (
      <Box p="40">
        <Loading />
      </Box>
    );
  }

  if (!modelGroups) {
    return null;
  }

  return (
    <>
      <Tabs>
        <TabList mb="8">
          <Tab>Taxable</Tab>
          <Tab>Tax-Deferred</Tab>
          <Tab>Tax-Free</Tab>
          <Tab>Other</Tab>
        </TabList>

        {MANUAL_ACCOUNTS_ASSET_ALLOCATION_TAX_STATUSES.map(taxStatusId => (
          <TabPanel key={taxStatusId}>
            <PortfolioPicker
              groups={modelGroups.modelPortfoliosGroups.map(g => ({
                ...g,
                modelPortfolios: g.modelPortfolios.map(m => ({
                  ...m,
                  assetAllocation: m.assetAllocationInputModel.map(aa => {
                    const defaultAsset = modelGroups.options.defaultAssetAllocation.find(
                      daa => daa.id === aa.id,
                    );
                    return defaultAsset ? { ...defaultAsset, y: aa.y } : aa;
                  }),
                  expectedReturn: formatPercentage(m.hypotheticalReturn ?? 0, { mantissa: 2 }),
                })),
              }))}
              modelId={
                currentAllocation.details?.[taxStatusId]
                  ? (currentAllocation.details[taxStatusId] as AssetAllocationModelDTO).id
                  : null
              }
              groupId={null}
              onModelChange={modelId => {
                const currentDetails = currentAllocation.details || {
                  TaxableInvestment: null,
                  TaxDeferred: null,
                  TaxFree: null,
                  Other: null,
                };

                setCurrentAllocation({
                  ...currentAllocation,
                  details: { ...currentDetails, [taxStatusId]: { id: modelId } },
                });
              }}
              isHiddenLeversRTQ={false}
              showRiskToleranceWorkflow={false}
              showPortfolioProjectedReturns={false}
            />
          </TabPanel>
        ))}
      </Tabs>
    </>
  );
};
